import {createEventBus} from '@malt/vue-event-bus/create-event-bus';

export type Events = {
    'funnel:previous:click': undefined;
    'funnel:next:click': undefined;
    'funnel:skip:click': undefined;
    'funnel:cancel': undefined;
    'funnel:not-my-team:click': undefined;
    'transition:after:enter': undefined;
};

export const eventBus = createEventBus<Events>();
